import React from 'react';
import ContinueButton from '../ChatsForm/ContinueButton';
import s from './ContactCar.scss';
import FormGroup from '../Common/FormGroup';
import Input from '../Common/Input';
import yup from 'yup';


const ContactCarForm = ({ agency, email, phone, errors, handleChange, submitUserInfo }) => {
    return (
        <div className={s.formWraper}>
            <h2 className={s.title}>Enviá tu pre-aprobado</h2>
            <FormGroup errors={errors.agency} className={s.formCarGroup}>
                <Input label="Agencia" name="agency" value={agency} onChange={handleChange} />
            </FormGroup>
            <FormGroup label="" errors={errors.email} className={s.formCarGroup}>
                <Input name="email" value={email || ''} onChange={handleChange} label="Email" />
            </FormGroup>
            <FormGroup lassName={s.formCarGroup}>
                <Input
                    errors={errors.phone}
                    validator={yup.mixed().test({
                        name: 'is-arg-phone',
                        message: 'El télefono no es válido para Argentina. Por favor agregá el código de área. Ej. 11 para Capital',
                        test: value => parseNumber(change15for11(value), 'AR', { extended: true }).valid
                    })}
                    name="phone"
                    value={phone || ''}
                    onChange={handleChange}
                    label="Teléfono"
                    type="tel"
                />
                <p className={s.helpText}>Ej.: 1160001234 o 2216000123 (Cod. de área sin el 0 + Número sin el 15)</p>
            </FormGroup>
            <ContinueButton onClick={submitUserInfo} disabled={(agency && phone && email) ? false : true} >Continuar</ContinueButton>
        </div>
    )
};

export default ContactCarForm;
